var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "div",
        { staticClass: "item-list-v2" },
        [
          _vm.field.name
            ? _c(
                "div",
                { staticClass: "label-item" },
                [
                  _c("p", { staticClass: "label-text" }, [
                    _vm._v(_vm._s(_vm.field.desc))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "light", placement: "bottom-start" }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v("\n                - name: "),
                          _c("strong", [_vm._v(_vm._s(_vm.field.name))]),
                          _c("br"),
                          _vm._v(
                            "\n                - 可以设置字段数量；\n                - 可以设置多项，点击 + 号新增；\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "label-icon el-icon-info" })
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.field.def_val.list || !_vm.field.def_val.list.length
            ? _c("div", { staticClass: "no-item" }, [
                _vm._v("暂无内容，点击 + 号新增")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.field, "label-width": "120px" }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "input-row", attrs: { label: "字段数量：" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 2, max: 6, label: "字段数量" },
                    model: {
                      value: _vm.field.def_val.extra,
                      callback: function($$v) {
                        _vm.$set(_vm.field.def_val, "extra", $$v)
                      },
                      expression: "field.def_val.extra"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "extra-sure-btn",
                      on: { click: _vm.extraSure }
                    },
                    [
                      _vm._v(
                        "点击更改字段数量：p1 - p" +
                          _vm._s(_vm.field.def_val.extra)
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "draggable",
                {
                  staticClass: "item-drag-area",
                  attrs: {
                    list: _vm.field.def_val.list,
                    options: _vm.draggableOpt
                  }
                },
                _vm._l(_vm.field.def_val.list, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "input-group drag-item" },
                    [
                      _c("span", { staticClass: "group-label" }, [
                        _vm._v(_vm._s("第(" + (index + 1) + ")项"))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.initPkey, function(item2, key) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              key: key,
                              staticClass: "input-row",
                              attrs: {
                                label: key,
                                prop: "def_val.list[" + index + "]." + key,
                                rules: _vm.fieldRules
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "field-input",
                                attrs: {
                                  placeholder:
                                    "请填写'" +
                                    (_vm.field.desc || "") +
                                    "(" +
                                    key +
                                    ")'的内容"
                                },
                                model: {
                                  value: item[key],
                                  callback: function($$v) {
                                    _vm.$set(item, key, $$v)
                                  },
                                  expression: "item[key]"
                                }
                              }),
                              _vm._v(" "),
                              _c("renderPreview", { attrs: { val: item[key] } })
                            ],
                            1
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _c("el-button", {
                        staticClass: "remove-btn",
                        attrs: { icon: "el-icon-delete", title: "删除该项" },
                        on: {
                          click: function($event) {
                            return _vm.remove(index)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-button", {
                        staticClass: "move-btn",
                        attrs: { icon: "el-icon-rank", title: "拖动此项" }
                      })
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "add-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.add }
                    },
                    [_vm._v("+")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07572b02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07572b02","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/itemListV2.vue
// module id = 1211
// module chunks = 7